<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content class="dialog-content-flex">
    <div class="textarea-container">
        <textarea [(ngModel)]="data.value" class="form-control textarea-fill"></textarea>
        <button type="button" class="copy-btn" (click)="copyToClipboard()" matTooltip="Copy to clipboard">
            <mat-icon class="icon-color-fix-orange">content_copy</mat-icon>
        </button>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-actions-fix">
    <button class="btn button-fix button-color-fix-red" mat-button (click)="onCancel()" cdkFocusInitial>Cancel</button>
    <button class="btn button-fix button-color-fix-orange"
            mat-button
            (click)="onSave()"
            [matTooltip]="'Save file content'">
        Save
        <mat-icon style="color:white !important" class="icon-color-fix">save</mat-icon>
    </button>
</mat-dialog-actions>
